import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingScreen } from '../../components/LoadingScreen';
import { isNative } from '../../platform/isNative';

const DEFAULT_MARKETING_ORIGIN = 'https://cantir.it';

function marketingOrigin(): string {
  const raw = import.meta.env.VITE_MARKETING_SITE_ORIGIN as string | undefined;
  if (raw && /^https?:\/\//i.test(raw.trim())) {
    return raw.trim().replace(/\/$/, '');
  }
  return DEFAULT_MARKETING_ORIGIN;
}

/** Redirect da vecchie route marketing della SPA verso il sito Astro (`cantir-landing`). */
function redirectUrl(pathname: string, search: string): string {
  const base = marketingOrigin();
  const q = search && pathname !== '/features' ? search : '';
  switch (pathname) {
    case '/':
      return `${base}/${q}`;
    case '/contact':
      return `${base}/contact${q}`;
    case '/privacy':
      return `${base}/privacy${q}`;
    case '/terms':
      return `${base}/terms${q}`;
    case '/features':
      return `${base}/#features`;
    case '/pricing':
      return `${base}/${q}`;
    default:
      return `${base}/${q}`;
  }
}

/**
 * Sostituisce la vecchia area pubblica (landing React). Chiamate a `/`, `/contact`, … su host app
 * vengono mandate al marketing statico.
 *
 * Su Capacitor (iOS/Android) non si esce dalla WebView verso cantir.it: si va al login prodotto.
 */
export function LegacyMarketingRedirectPage() {
  const { pathname, search } = useLocation();
  const native = isNative();

  useEffect(() => {
    if (native) return;
    window.location.replace(redirectUrl(pathname, search));
  }, [pathname, search, native]);

  if (native) {
    return <Navigate to="/login" replace />;
  }

  return <LoadingScreen />;
}
